import React from 'react';
import { Hourglass } from 'lucide-react';
import styled from 'styled-components';

const Wrap = styled.div`
  position: relative;
  margin-bottom: ${({ $mb }) => ($mb ? '24px' : '0')};
`;

const Dimmed = styled.div`
  pointer-events: none;
  user-select: none;
  opacity: 0.45;
`;

const Scrim = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px;
  border-radius: 16px;
  background: rgba(245, 241, 234, 0.72);
  backdrop-filter: blur(3px);
  border: 1px solid var(--line);

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    margin-bottom: 8px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: var(--o-tint);
    color: var(--o-deep);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    max-width: 280px;
    font-size: 12px;
    line-height: 18px;
    color: var(--quiet);
  }
`;

export default function FeatureOverlay({
  visible = true,
  title = 'Coming Soon',
  subtitle = 'This feature is under development.',
  className,
  children,
}) {
  if (!visible) return children;

  return (
    <Wrap className={className} $mb>
      <Dimmed aria-hidden="true">{children}</Dimmed>
      <Scrim>
        <div className="badge">
          <Hourglass size={14} />
          {title}
        </div>
        {subtitle ? <p>{subtitle}</p> : null}
      </Scrim>
    </Wrap>
  );
}
